{
  "labels": {
    "skeniraj": "Scansiona il codice qui sotto con il tuo autenticatore:",
    "vnesiKodo": "Inserisci il codice generato nell'autenticatore",
    "prepisi": "Trascrivi il codice nell'autenticatore:",
    "kodaNiVidna": "Se non vedi il codice, clicca qui per mostrarlo",
    "skrij": "Nascondi codice",
    "nastavljeno": "2FA è già impostato per questo account",
    "niNastavljeno": "2FA non è ancora impostato per questo account",
    "buttons": {
      "odpri": "Attiva / Disattiva 2FA",
      "vklopi": "Attiva l'autenticazione a due fattori",
      "izklopi": "Disattiva l'autenticazione a due fattori",
      "ponastavi": "Reimposta autenticatore",
      "generiranje": "Attivazione in corso",
      "deaktivacija": "Disattivazione in corso",
      "ponastavljanje": "Reimpostazione in corso",
      "potrdiKodo": "Conferma codice"
    }
  },
  "obvestila": {
    "napakaBranja": "Errore nella lettura dei dati.",
    "napakaInputa": "Il campo codice non può essere vuoto!",
    "vprasanjeIzklopa": "Sei sicuro di voler disattivare 2FA?",
    "izklopUspesen": "2FA disattivato con successo.",
    "vklopUspesen": "2FA attivato con successo.",
    "niUjemanja": "Il codice inserito non corrisponde. Controlla il codice inserito e riprova!"
  }
}